import { CSSProperties } from 'react';
import { useReduxState } from 'hooks';
import { getMessageWithPlaceholders } from 'shared-locales';
import { getFormattedDate } from 'lib/common';
import { Alert } from 'components/common';

interface Props {
  date: string;
  style?: CSSProperties;
  visible?: boolean;
}

const AnalyticsDeletedUsersWarning = ({
  date,
  style,
  visible = false
}: Props) => {
  const { messages } = useReduxState();

  const referenceDate = new Date(2022, 9, 1).getTime(); // month is 0-index based
  const referenceMessage = getMessageWithPlaceholders({
    message: messages.analyticsDeletedAccountsWarning,
    placeholders: { date: getFormattedDate({ date: referenceDate }) }
  });

  return visible && Date.parse(date) <= referenceDate ? (
    <Alert
      size="medium"
      style={style}
      text={referenceMessage}
      type="warning-light"
    />
  ) : null;
};

export default AnalyticsDeletedUsersWarning;
